import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import SEO from "./components/SEO";
import Home from "./pages/Home";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";
import PageView from "./pages/PageView";
import Vendors from "./pages/Vendors";
import GetFeatured from "./pages/GetFeatured";
import Login from "./pages/admin/Login";
import Admin from "./pages/admin/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (!pathname.startsWith("/admin")) {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ path: pathname }),
      }).catch(() => {});
    }
  }, [pathname]);
  return null;
}

const HOME_DESC = "The Brides of India, founded in Mumbai in 2011, is India's first and largest wedding media house. Trends, real weddings, decor, floral, music and celebrity wedding coverage across India and the diaspora.";
const EDIT_DESC = "The Brides of India Edit: wedding stories, trend reports, real weddings, style guides and ideas worth remembering, filed by our editors in Mumbai.";
const VENDORS_DESC = "The TBOI Directory: wedding planners, couturiers, photographers and artisans trusted by The Brides of India.";
const FEATURED_DESC = "Get featured on The Brides of India. Join 1000+ brands and couples showcased to one of the most engaged wedding audiences in India and the diaspora.";

function Site() {
  return (
    <div className="min-h-screen flex flex-col">
      <Nav />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<><SEO title="" description={HOME_DESC} /><Home /></>} />
          <Route path="/edit" element={<><SEO title="The Edit" description={EDIT_DESC} /><BlogList /></>} />
          <Route path="/edit/:slug" element={<BlogPost />} />
          <Route path="/vendors" element={<><SEO title="Vendor Directory" description={VENDORS_DESC} /><Vendors /></>} />
          <Route path="/get-featured" element={<><SEO title="Get Featured" description={FEATURED_DESC} /><GetFeatured /></>} />
          <Route path="/page/:slug" element={<PageView />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      lerp: 0.14,
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.75,
    });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/*" element={<Site />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
